import { gql } from '@apollo/client';
import { PatientListInfoShared } from '../fragments';

export default gql`
  query patients(
    $accountId: ID
    $partnerOrganizationId: ID
    $partnerLocationId: ID
    $scanReady: Boolean
    $withoutOrders: Boolean
    $activeAccount: Boolean
    $imported: Boolean
    $withoutScan: Boolean
    $includeEot: Boolean
    $settingsOverride: Boolean
    $createdAtStart: String
    $createdAtEnd: String
    $limit: Int
    $offset: Int
  ) {
    patients(
      accountId: $accountId
      partnerOrganizationId: $partnerOrganizationId
      partnerLocationId: $partnerLocationId
      scanReady: $scanReady
      withoutOrders: $withoutOrders
      activeAccount: $activeAccount
      imported: $imported
      withoutScan: $withoutScan
      includeEot: $includeEot
      settingsOverride: $settingsOverride
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      limit: $limit
      offset: $offset
    ) {
      ...PatientListInfoShared
    }
  }
  ${PatientListInfoShared}
`;
